<mb-dynamic-container
  [observedWidths]="videoBreakpoints"
  (widthChanged)="wrapperWidthChanged($event)"
  #dynamicWrapper
  class="dynamic-wrapper"
  [class.auto-height]="smallPlayer && showTranscript"
>
  <div class="wrapper">
    <mb-resizable-container
      #wrapperResizeContainer
      class="wrapper-resize-container"
      dragArea="bottom"
      [class.transcript-open]="showTranscript"
      [class.small-video]="smallPlayer"
      [class.full-width]="!smallPlayer"
      [class.auto-height]="!showTranscript"
      (resizeUpdate)="calculateVideoDimensions(true)"
      [class.full-height]="player?.isFullscreen"
      [canResize]="smallPlayer && showTranscript"
      (isOutsideClick)="hideControls()"
    >
      <div class="player-wrapper-outer-wrapper">
        <div class="player-wrapper-outer">
          <div class="player-wrapper-inner">
            <mb-resizable-container
              dragArea="right"
              class="wrapper-resize-container-inner"
              [canResize]="!smallPlayer && showTranscript"
              (initUpdate)="calculateVideoDimensions()"
              (resizeUpdate)="calculateVideoDimensions()"
              [class.full-width]="!showTranscript || smallPlayer"
              [class.auto-height]="!smallPlayer"
              (isOutsideClick)="hideControls()"
            >
              <mb-dynamic-container
                class="wrapper-dynamic-container-inner"
                [observedWidths]="controlBreakpoints"
                (widthChanged)="checkControlWidth($event)"
                (touchstart)="showControls()"
              >
                <div
                  class="player-container"
                  [class.paused]="($safeNavigationMigration(player?.playing$) | async) === false"
                  #playerContainer
                  (mousemove)="showControls()"
                >
                  <div class="video-container">
                    <div
                      #videoParent
                      class="video-wrapper"
                      [style.height.px]="dimensions.height"
                      [style.width.px]="dimensions.width"
                      [class.composed-player]="player?.playerData?.isComposed"
                    ></div>
                  </div>
                  <div
                    class="video-title-wrapper video-title-wrapper-top"
                    [class.player-hovered]="showControls$ | async"
                    [class.paused]="($safeNavigationMigration(player?.playing$) | async) === false"
                  >
                    @if (!hideTitle || showBackButton) {
                      <span class="video-title-btn copy-s btn btn-plain" (click)="backButton.emit()">
                        <span class="mb-icon mb-icon-step-back"></span>
                        @if (!hideTitle) {
                          <span [innerHTML]="media.title"></span>
                        }
                      </span>
                    }
                    @if (!showBackButton) {
                      <span [innerHTML]="media.title"></span>
                    }
                  </div>
                  @if (!hideBottomTitle) {
                    <div
                      class="video-title-wrapper video-title-wrapper-bottom font-family-title title"
                      [class.hidden]="smallControls"
                      [class.paused]="($safeNavigationMigration(player?.playing$) | async) === false"
                      [innerHTML]="media.title"
                    ></div>
                  }
                  @if (player) {
                    <mb-video-controls
                      [smallControls]="smallControls"
                      [showControls]="(showControls$ | async) || (player.playing$ | async) === false"
                      [player]="player"
                      [media]="media"
                      [isEmbedPlayer]="isEmbedPlayer"
                      [allowPictureInPicture]="allowPictureInPicture && !player.isFullscreen"
                      (capture)="showCapture($event)"
                    ></mb-video-controls>
                  }
                </div>
                @if (thumbsOpen && smallControls && !smallPlayer) {
                  <mb-thumb-control
                    cdkDrag
                    cdkDragBoundary="mb-video"
                    class="scale-on-video hide-handle-bar show-bg"
                    [player]="player!"
                    [maxHeight]="wrapperResizeContainer.elRef.nativeElement.clientHeight - 140"
                    (positionUpdated)="toggleThumbs(false)"
                    (closeThumb)="toggleThumbs(false)"
                  >
                    <div cdkDragHandle></div>
                  </mb-thumb-control>
                }
              </mb-dynamic-container>
            </mb-resizable-container>

            @if (!smallPlayer) {
              <ng-container *ngTemplateOutlet="transcriptTpl"></ng-container>
            }
          </div>
        </div>
      </div>
    </mb-resizable-container>
    @if (!isEmbedPlayer) {
      <div
        #buttonHub
        class="video-button-hub"
        [class.small-video]="smallPlayer"
        [class.small-controls]="smallControls"
        [class.hide]="smallPlayer && showTranscript"
      >
        @if (player?.playerData?.isComposed) {
          <div class="btn multiangle-btn" [class.btn-quaternary]="thumbsOpen" (click)="toggleThumbs()">
            <span
              class="mb-icon"
              [class.mb-icon-favorites-press-map]="!thumbsOpen"
              [class.mb-icon-close]="thumbsOpen"
            ></span>
            <span>{{ (thumbsOpen ? 'MULTIANGLE_EXIT' : 'MULTIANGLE') | translate }}</span>
          </div>
        }
        <div class="btn-spacer"></div>
        <div class="share-btn btn btn-quaternary" (click)="openShare()">
          <span class="mb-icon mb-icon-sharing"></span>
          @if (!player?.playerData?.qaForm && !player?.playerData?.transcript) {
            <span>{{ 'SHARE' | translate }}</span>
          }
        </div>
        @if (!isEmbedPlayer && player?.playerData?.qaForm && player?.playerData?.showQaButton) {
          <div class="btn btn-secondary-dark" (click)="openQaForm()">
            <span class="mb-icon mb-icon-chat-line"></span>
            <span>{{ 'ASK_QUESTION' | translate }}</span>
          </div>
        }
        @if (transcript) {
          <div class="btn btn-secondary-dark" (click)="toggleTranscript(!showTranscript)">
            <span class="mb-icon mb-icon-menue-content"></span>
            <span>{{ (showTranscript ? 'TRANSCRIPT_DISABLE' : 'TRANSCRIPT_ENABLE') | translate }}</span>
          </div>
        }
      </div>
    }
  </div>
</mb-dynamic-container>

@if (smallPlayer && showTranscript) {
  <div class="mobile-transcript-wrapper">
    <ng-container *ngTemplateOutlet="transcriptTpl; context: { mobile: true }"></ng-container>
  </div>
}

<ng-template #transcriptTpl let-mobile="mobile">
  @if (player && transcript && showTranscript) {
    <div class="transcript-container">
      <mb-transcript
        (langChanged)="changeTranscriptLang($event)"
        [transcript]="transcript"
        [player]="player"
        [isMobile]="mobile"
        (closeTranscript)="toggleTranscript(false)"
        (openMedia)="openMedia.emit($event)"
      ></mb-transcript>
    </div>
  }
</ng-template>
@if (thumbsOpen) {
  <mb-thumb-control
    cdkDrag
    cdkDragBoundary="mb-video"
    [maxHeight]="wrapperResizeContainer.elRef.nativeElement.clientHeight - 140"
    [class.show-bg]="smallPlayer"
    [class.hide-handle-bar]="smallPlayer"
    [class.mobile-thumb-control]="smallPlayer"
    [player]="player!"
    [style.width.px]="playerContainer"
    (positionUpdated)="thumbPositionUpdated()"
    (closeThumb)="toggleThumbs(false)"
  >
    <div cdkDragHandle></div>
  </mb-thumb-control>
}
